<template>
  <el-select :style="{
    '--color': color,
    '--bg--color': bgColor,
  }" v-bind="$attrs" v-model="values" @change="params=>$emit('change',params)">
    <el-option v-for="item in list" :key="item.选中数据" :label="item.显示数据" :value="item.选中数据">
    </el-option>
  </el-select>
</template>

<script>

export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    color: {
      type: String,
      default: '#333'
    },
    bgColor: {
      type: String,
      default: '#fff'
    },
    list: {
      type: Array,
      default: () => []
    }
  },
  mixins: [],
  data() {
    return {};
  },
  computed: {
    values: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
  beforeDestroy() {
  },
  destroyed() {
  },
}

</script>

<style scoped lang="scss">
::v-deep .el-input__inner {
  color: var(--color) !important;
  background-color: var(--bg--color) !important;
}

</style>

